import { makeStyles } from '@mui/styles';
import { APP_ACTION_COLUMNS } from '../../../utils/constants';

const styles = makeStyles(() => ({
  dataGrid: {
    width: '100%',
    backgroundColor: '#f0f0f0',
  },
  rowLockedActions: {
    '& .MuiDataGrid-cell': {
      pointerEvents: 'none',
      opacity: 0.5,
    },
  },
  rowViewMode: {
    '& .MuiDataGrid-cell': {
      pointerEvents: 'none',
    },
    ...Object.fromEntries(
      APP_ACTION_COLUMNS.map((field) => [
      `& .MuiDataGrid-cell[data-field="${field}"]`,
      {
        pointerEvents: 'auto',
      },
      ])
    ),
  },
}));

export default styles;
